Core.ProjectsRouter = Core.SubRouter.extend({
    routes: {
        '': 'projects',
        'new': 'newProject',
        ':id': 'viewProject',
        ':id/edit': 'editProject',

    },

    projects: function () {
        debug.log('projects');
        var view = new ProjectListView({ scrolling: true });
        var hash = Core.param('hash');
        if (hash) this.navigate(hash, { trigger: true, replace: true });
        else view.fetchList('all');
        app.setMainView(view, 'projects', { wideContainer: true });
    },

    newProject: function () {
        debug.log('new project');
        var view = new ProjectDetailsView({});
        view.editing = true;
        view.fillInDefaults();
        app.setMainView(view, 'projects');
    },

    viewProject: function (id) {
        debug.log('view project', id);
        var view = new ProjectDetailsView({});
        if (Core.param('returnTo')) view.saveAction = Core.param('returnTo');

        view.editing = false;
        if (!view.model || view.model.id != id) view.setModel(new Project({ id: id }));
        app.setMainView(view, 'projects');
    },

    editProject: function(id) {
        debug.log('edit job', id);
        var view = new ProjectDetailsView({});
        if (Core.param('returnTo')) view.saveAction = Core.param('returnTo');

        view.editing = true;
        if (!view.model || view.model.id != id) view.setModel(new Project({id: id}));
        else view.change();
        app.setMainView(view, 'projects');
    },
})